import React from "react";

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding p-t80 p-b10 bg-repeat">
          <div className="container">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner">
                  <h1 className="mb__30">IMR Media</h1>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 sx-separator-outer separator-center">
                <div className="case-logo custom__case_study_website_logo small__logo">
                  <img
                    src={require("./../../../images/imr_media/logo.webp")}
                    className=""
                    alt="Shadow Case Study Logo"
                  />
                </div>
                <div className="mxnv046">
                  <h5 className="dfghj876543">IMR Media</h5>
                  <ul className="scnv-case mb__0">
                    <li>
                      <b>Location : </b>
                      8A, Ashok Marg, Silokhra, Gurgaon 122001, India
                    </li>

                    <li>
                      <b>Speciality : </b> Government Affliated Think Tank
                    </li>

                    <li className="pb__0 mb__0">
                      <b>Website : </b>{" "}
                      <a
                        href="https://imrmedia.in/"
                        class="text-white"
                        target="_blank"
                      >
                        www.imrmedia.in
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-8 col-md-12 sx-separator-outer">
                <div className="case-web-banner">
                  <img
                    src={require("./../../../images/imr_media/mobile_banner.webp")}
                    className="phone-banner"
                    alt="Shadow"
                  />
                  <img
                    src={require("./../../../images/imr_media/desktop_banner.webp")}
                    className="web-banner"
                    alt="Shadow"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="section-content">
              <div className="qpqq">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="bg-white">
                      <h2 class="ert678">Introduction</h2>
                      <p className="mb__0">
                        IMR Media is a 360-degree military media company which
                        publishes the digital Indian Military Review, organises
                        military conferences & exhibitions (virtual and
                        physical) and publishes books. IMR Media organizes
                        Defence Seminars and Exhibitions on Night Vision, CBRNe,
                        Precision Attack, Force Protection & Soldier Technology,
                        Military Simulation & Training, Air Defence, Unmanned
                        Aerial Vehicles, Strategic Electronics, Maritime &
                        Coastal Security, Military Logistics & Transportation,
                        Digital Army, Multi-domian operations, Netcentric
                        Warfare, ISTAR & Precision Targeting, Cutting Edge
                        Technologies, and so on. IMR Media also offers to
                        organize bespoke Round Table Discussions and
                        Consultancy/Advisory Services.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
